import { useGetTokenData } from "./useGetTokenData";

type IRolesStr = "buyer" | "holding" | "partner" | "guest" | "admin";

export const useCanAccessByRole = (roles: IRolesStr[]) => {
  const tokenData = useGetTokenData();
  if (!tokenData) return false;
  return tokenData.roles.some((e) => roles.includes(e as IRolesStr));
};
